import React, { useState } from 'react';
import { useFeriasVencimentos } from 'features/dp/hooks/useFeriasVencimentos';
import FeriasVencimentoBanner from './FeriasVencimentoBanner';
import FeriasVencimentoTabela from './FeriasVencimentoTabela';

/**
 * Seção de controle de vencimento de férias.
 * Exibe banner de alerta e tabela filtrável com situação de cada funcionário.
 *
 * Uso: incluir na aba Férias do módulo Departamento Pessoal.
 */
export default function FeriasVencimentos() {
  const [statusFiltro, setStatusFiltro] = useState('todos');
  const { dados, loading, error, recarregar } = useFeriasVencimentos(statusFiltro);

  return (
    <div className="space-y-4">
      <FeriasVencimentoBanner dados={dados} loading={loading} />
      <FeriasVencimentoTabela
        dados={dados}
        loading={loading}
        error={error}
        statusAtivo={statusFiltro}
        onStatusChange={setStatusFiltro}
        onRecarregar={recarregar}
      />
    </div>
  );
}
